import 'normalize.css/normalize.css';
import 'babel-polyfill';
import {render} from 'react-dom';
import Routes from './routes';

// // Catching unhandled exceptions natively 
// window.addEventListener("unhandledrejection", err => {
//     throw err?.detail?.reason ? err?.detail?.reason : "";
// });
// Catching unhandled promise rejections
window.addEventListener("unhandledrejection", (event) => {
    // Log the unhandled promise rejection
    if (event.reason) {
        console.error("Unhandled Promise Rejection:", event.reason);
        // Optionally send the error to an error tracking service
        // reportToErrorService(event.reason);
    } else {
        console.error("Unhandled Promise Rejection with no reason:", event);
    }

    // Avoid throwing to prevent breaking the page
});

render(Routes, document.getElementById('react-root'));
